import Views from '../../views/entry/orgUnitAdminUser/OrgUnitAdminUserViews';
import getInitialStateOmeRoute from './GetInitialStateOmeRoute';
import getInitialStateMeetRoute from './GetInitialStateMeetRoute';
import { contactsIsComplete, credentialsIsComplete, rosterEntriesIsComplete, submitIsComplete } from './LeftNavValidation';

const getSubmit = (viewName, route, orgUnitAthleteEntryInfoStateObjData) => {
  const isCurrent = ((viewName === Views.OME_MEET_SUBMIT) || (viewName === Views.OME_MEET_SUBMITTED)) === true ? true : false;

  const isContactsComplete = contactsIsComplete(orgUnitAthleteEntryInfoStateObjData);
  const isRosterEntriesComplete = rosterEntriesIsComplete(orgUnitAthleteEntryInfoStateObjData);
  const isCredentialsComplete = credentialsIsComplete(orgUnitAthleteEntryInfoStateObjData);

  const arePrerequisitesDone = isContactsComplete === true && isRosterEntriesComplete === true && isCredentialsComplete === true;

  const isComplete = isContactsComplete === true && isRosterEntriesComplete === true && isCredentialsComplete === true && submitIsComplete();

  const item = route === '' ? getInitialStateOmeRoute(Views.OME_MEET_SUBMIT) : getInitialStateMeetRoute(Views.OME_MEET_SUBMIT);

  return {
    ...item,
    isCurrent,
    isComplete,
    arePrerequisitesDone
  };
};

export default getSubmit;